import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVisa, Core2Config, Pagination, PagingResponseModel } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { ItemEntityPricingContainerModel } from '../../../../../models/aggregates/item-entity-pricing/item-entity-pricing-container.model';

@Injectable({ providedIn: 'root' })
export class ItemEntityPricingService extends BaseApiTemplateService<ItemEntityPricingContainerModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/item-entity-pricing-links';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/item-entity-pricing-links';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/item-entity-pricing-links';
        this.httpClient = http;
    }

    public getByCriteriaV2(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<ItemEntityPricingContainerModel>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const UrlByCriteria = this.apiUrl + "/" + Core2Config.BACKOFFICE_EP_SUFFIX + '/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<ItemEntityPricingContainerModel>>(UrlByCriteria,this.getHttpHeader(visa));
    }
}
